import { render, staticRenderFns } from "./DialogoDeDetalhesDaTransferencia.vue?vue&type=template&id=200dc184&"
import script from "./DialogoDeDetalhesDaTransferencia.vue?vue&type=script&lang=ts&"
export * from "./DialogoDeDetalhesDaTransferencia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardTitle,VDataTable,VDialog})
